<template>
  <el-form
    ref="userForm"
    :model="model"
    :rules="rules"
    label-width="9.5em"
    label-position="left"
    class="user-form"
  >
    <template v-if='programName !=="UserMasterChangePassword"' >
      <div class="el-form--inline">
        <UserId v-model="userId" :required="!searchMode" :searchCond="searchMode"
          :disabled="editMode" :autofocus="!editMode" :autocomplete-list="autocompleteUserIdSet" />
        <Blank />
      </div>
      <div class="el-form--inline">
        <UserName v-model="userName" :required="!searchMode" :searchCond="searchMode"
          :autocomplete-list="autocompleteUserNameSet" />
      </div>
      <div class="el-form--inline">
        <PhoneNumber v-model="phoneNumber" :required="!searchMode" :searchCond="searchMode"
        :autocomplete-list="phoneNumberSet" />
        <Email v-model="email" :required="!searchMode" :searchCond="searchMode"
        :autocomplete-list="emailSet" />
      </div>
      <div class="el-form--inline">
        <template v-if='formMode === "search"'>
          <!-- <CustomerCodeInput v-model="customerCode" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" /> -->
          <CustomerCodeInput v-model="customerCode" :required="!searchMode" :searchCond="searchMode"
              :autocomplete-list="autocompleteCustomerCodeSet" :disabled="editMode"/>
        </template>
        <template v-else>
          <CustomerCodeSelect :disabled='programName ==="UserInformation"' v-model="customerCode" :required='!searchMode && programName !=="UserInformation"' :searchCond="searchMode" :initialize="true" :ownCompany="true"/>
        </template>
        <RoleId :disabled='programName ==="UserInformation"' v-model="roleId" :required='!searchMode && programName !=="UserInformation"' :searchCond="searchMode" :initialize="true" />
      </div>
      <div class="el-form--inline changePassword">
        <template v-if='loginUserRoleId === "admin"'>
          <Blank />
          <el-checkbox v-model="changePassword" v-if="editMode" >パスワードをリセットする</el-checkbox>
        </template>
      </div>
    </template>
    <template v-else>
      <Password v-model="passWord" :required="true" label="新パスワード"/>
      <Password v-model="passWordConfirm" :required="true"  label="確認パスワード"/>
    </template>
  </el-form>
</template>

<script>
import UserId from '@/components/molecules/form/autocomplete/UserId.vue'
import UserName from '@/components/molecules/form/autocomplete/UserName.vue'
import CustomerCodeInput from '@/components/molecules/form/autocomplete/CustomerCode.vue'
import CustomerCodeSelect from '@/components/molecules/form/select/CustomerCode.vue'
import PhoneNumber from '@/components/molecules/form/text/PhoneNumber.vue'
import Email from '@/components/molecules/form/autocomplete/Email.vue'
import RoleId from '@/components/molecules/form/select/RoleId.vue'
import Password from '@/components/molecules/form/text/Password.vue'
import Blank from '@/components/molecules/form/text/Blank.vue'

export default {
  components: {
    UserId,
    UserName,
    CustomerCodeInput,
    CustomerCodeSelect,
    PhoneNumber,
    Email,
    RoleId,
    Password,
    Blank
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    programName: {
      type: String,
      default: ''
    },
    rules: Object,
    autocompleteUserIdSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteUserNameSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      loginUserRoleId: this.$loginuser.get('role_id')
    }
  },
  computed: {
    userId: {
      get () {
        return this.model.user_id
      },
      set (userId) {
        const form = { ...this.model }
        form.user_id = userId
        this.$emit('input', form)
      }
    },
    userName: {
      get () {
        return this.model.user_name
      },
      set (userName) {
        const form = { ...this.model }
        form.user_name = userName
        this.$emit('input', form)
      }
    },
    customerCode: {
      get () {
        return this.model.customer_code
      },
      set (customerCode) {
        const form = { ...this.model }
        form.customer_code = customerCode
        this.$emit('input', form)
      }
    },
    phoneNumber: {
      get () {
        return this.model.phone_number
      },
      set (phoneNumber) {
        const form = { ...this.model }
        form.phone_number = phoneNumber
        this.$emit('input', form)
      }
    },
    email: {
      get () {
        return this.model.email
      },
      set (email) {
        const form = { ...this.model }
        form.email = email
        this.$emit('input', form)
      }
    },
    roleId: {
      get () {
        return this.model.role_id
      },
      set (roleId) {
        const form = { ...this.model }
        form.role_id = roleId
        this.$emit('input', form)
      }
    },
    passWord: {
      get () {
        return this.model.password
      },
      set (passWord) {
        const form = { ...this.model }
        form.password = passWord
        this.$emit('input', form)
      }
    },
    passWordConfirm: {
      get () {
        return this.model.password_confirm
      },
      set (passWordConfirm) {
        const form = { ...this.model }
        form.password_confirm = passWordConfirm
        this.$emit('input', form)
      }
    },
    changePassword: {
      get () {
        return this.model.change_password
      },
      set (changePassword) {
        const form = { ...this.model }
        form.change_password = changePassword
        this.$emit('input', form)
      }
    },
    updateDate: {
      get () {
        return this.model.updated_on
      },
      set (updateDate) {
        const form = { ...this.model }
        form.updated_on = updateDate
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    }
  },
  mounted () {
  },
  open () {
    this.changePassword = false
  },
  methods: {
    clearFields () {
      this.$refs.userForm.resetFields()
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.userForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  color: red;
}
.user-form {
  // .el-form-item.user-name{
  //   .el-input__inner{
  //     width: 49em;
  //   }
  // }
  .el-form-item.email{
    .el-input__inner{
      width: 20em;
    }
  }
  .el-form-item.role-id{
    .el-input__inner{
      width: 20em;
    }
  }
}
</style>
